<template>
  <BaseInput
    type="tel"
    :label="label"
    :placeholder="placeholder"
    :value="national"
    :error="error"
    v-bind="$attrs"
    @input="handleNationalInput"
  >
    <!-- Selector de pais: el select nativo va invisible encima de la bandera y la lada -->
    <template slot="left-side">
      <div
        class="relative h-12 flex items-center pl-3 pr-2 border-r border-gray-300 text-sm whitespace-nowrap"
      >
        <span>{{ country.flag }} +{{ country.dial }}</span>
        <svg class="h-3 w-3 ml-1 text-gray-500 fill-current" viewBox="0 0 20 20">
          <path
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          />
        </svg>
        <select
          class="absolute inset-0 w-full opacity-0 cursor-pointer"
          aria-label="Pais"
          :value="iso"
          @change="handleCountryChange($event.target.value)"
        >
          <option v-for="option in countries" :key="option.iso" :value="option.iso">
            {{ option.name }} (+{{ option.dial }})
          </option>
        </select>
      </div>
    </template>
  </BaseInput>
</template>

<script>
import BaseInput from '@/components/BaseInput';
import { countries, findCountry, joinPhone, splitPhone } from '@/util/countries';

/**
 * Telefono internacional para WhatsApp.
 *
 * El v-model recibe y emite el numero completo con lada ("+525512345678"),
 * que es como lo espera el backend. Lo que se escribe en la caja es solo el
 * numero nacional; la lada sale del pais elegido.
 */
export default {
  name: 'PhoneInput',
  components: { BaseInput },
  inheritAttrs: false,
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: 'WhatsApp' },
    placeholder: { type: String, default: 'Telefono (opcional)' },
    error: { type: String, default: null },
    defaultCountry: { type: String, default: 'MX' },
  },
  data() {
    return {
      countries,
      iso: this.defaultCountry,
      national: '',
      // Ultimo valor emitido, para no re-separar lo que nosotros mismos mandamos.
      emitted: null,
    };
  },
  computed: {
    country() {
      return findCountry(this.iso) || findCountry(this.defaultCountry);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === this.emitted) {
          return;
        }

        // Un formulario limpio regresa al pais por defecto.
        const { iso, national } = splitPhone(value, value ? this.iso : this.defaultCountry);
        this.iso = iso;
        this.national = national;
      },
    },
  },
  methods: {
    handleNationalInput(national) {
      this.national = national;
      this.emitValue();
    },
    handleCountryChange(iso) {
      this.iso = iso;
      this.emitValue();
    },
    emitValue() {
      this.emitted = joinPhone(this.iso, this.national);
      this.$emit('input', this.emitted);
    },
  },
};
</script>
